import { ProductConfig } from "@core/interface/environment.interface";
import { ProductEnum } from "../product.enum";

export const ZodpovednostEnvironment: ProductConfig = {
    baseUrl: "",
    schemaEndpoint: "./api/v1/responsibility-report",
    productUrl: ProductEnum.ZODPOVEDNOST,
    skipSteps: [
        {
            skipStepName: 'damaged-vehicles', // poskodenie vozidla
            conditions: [
                {
                    stepName: 'incident-description',
                    param: 'damagedObjects',
                    subParam: 'choices',
                    values: ['1'],
                    negotiate: true
                }
            ]
        },
        {
            skipStepName: 'injured-persons', // zraneni ludia
            conditions: [
                {
                    stepName: 'incident-description',
                    param: 'damagedObjects',
                    subParam: 'choices',
                    values: ['2'],
                    negotiate: true
                }
            ]
        },
        {
            skipStepName: 'other-damages', // ina skoda
            conditions: [
                {
                    stepName: 'incident-description',
                    param: 'damagedObjects',
                    subParam: 'choices',
                    values: ['3'],
                    negotiate: true
                }
            ]
        },
        {
            skipStepName: 'payment',
            conditions: [
                {
                    langInstance: 'cz'
                }
            ]
        }
    ],
    maxSingleFileSizeUpload: null,
    maxBulkFilesSizeUpload: 19000000,
    deployUrl: ProductEnum.ZODPOVEDNOST + '/'
};